var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.doctors),function(doctor){return _c('span',{key:doctor.id},[_c('span',{staticClass:"colorbox",style:({background: doctor.color})}),_c('span',{staticClass:"doctorname"},[_vm._v(_vm._s(_vm.doctor_name(doctor.doctor)))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }